import { RelatedInventoryRiskItem } from '../../../Api/Projects/projectsApi';
import { RiskBanner } from './RiskBanner';
import { RiskWidgetCard } from './RiskWidgetCard';
import { RISK_TIER_DEFAULT_LABELS } from './riskTierStyles';

export interface MiniRiskWidgetProps {
  item: Pick<RelatedInventoryRiskItem, 'riskTier' | 'riskLabel' | 'riskMessage'>;
  className?: string;
}

// Compact risk indicator for an asset detail surface: the tier label strip over a dark
// card with the configured risk message. Unscored items (no risk dates) render nothing.
export const MiniRiskWidget = ({ item, className }: MiniRiskWidgetProps) => {
  const { riskTier, riskLabel, riskMessage } = item;
  if (!riskTier) return null;

  return (
    <div
      className={className}
      data-testid="mini-risk-widget"
      data-cy="mini-risk-widget">
      <RiskWidgetCard
        banner={
          <RiskBanner
            tier={riskTier}
            testId="mini-risk-banner">
            {riskLabel || RISK_TIER_DEFAULT_LABELS[riskTier]}
          </RiskBanner>
        }>
        <span className="text-sm text-white">{riskMessage}</span>
      </RiskWidgetCard>
    </div>
  );
};
